module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7n6r5r1r-6a2786c886580227195f5d3c6f72e302.svg";